import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTimer2 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		title === undefined ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: "timer"
		}) : title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,.75a11.245,11.245,0,1,1-9.952,6"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 1.5,
			y1: 1.5,
			x2: 12,
			y2: 12
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M7.875,1.5a.375.375,0,1,1-.375.375A.375.375,0,0,1,7.875,1.5"
		})
	]
});
const ForwardRef = forwardRef(SvgTimer2);
export default ForwardRef;
